import { useEffect } from 'react';
import PropTypes from 'prop-types';

function CameraAccessChecker({ setError, setIsModelLoading }) {
  useEffect(() => {
    const checkCamera = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasCamera = devices.some((device) => device.kind === 'videoinput');
        if (!hasCamera) {
          throw new Error('No camera detected');
        }
        console.log('Camera device detected');
      } catch (err) {
        console.error('Camera check error:', err);
        setError('Camera access denied or no camera detected. Please allow permissions or connect a camera.');
        setIsModelLoading(false);
      }
    };
    checkCamera();
  }, [setError, setIsModelLoading]);

  return null;
}

CameraAccessChecker.propTypes = {
  setError: PropTypes.func.isRequired,
  setIsModelLoading: PropTypes.func.isRequired
};

export default CameraAccessChecker;
